import React from 'react'
import { useAppDispatch, useAppSelector } from '@SonarCX/hooks/redux'

import MultipleMenuSection from '../MultipleMenuSection'

import { getIDs, getNames } from '../../helpers/parse'
import { selectTaskType, fetchTypes } from '@SonarCX/slices/taskType'
import { useTaskFilters } from '@SonarCX/providers/TaskFiltersProvider'

type TypeFilterProps = {
  checkFilters?: boolean
  menuMode?: boolean
  closeModal?: () => void
}

const TypeFilter: React.FC<TypeFilterProps> = props => {
  const dispatch = useAppDispatch()

  const { typesValues, loaded, loading } = useAppSelector(selectTaskType)

  const { state, handleChange } = useTaskFilters()

  // Fetch types if not loaded
  React.useEffect(() => {
    if (!loaded && !loading) {
      dispatch(fetchTypes())
    }
  }, [loaded, loading, dispatch])

  return (
    <MultipleMenuSection
      title='Types'
      options={getIDs(typesValues)}
      value={state.typeValue}
      setValue={handleChange('typeValue')}
      transform={getNames(typesValues)}
      unassignedOpt='All Types'
      {...props}
    />
  )
}

export default TypeFilter
